/* Shop by car make — A-Z index behaviour.
 * Filter box narrows the list as you type; empty letter groups hide so the
 * page never shows a heading with nothing under it. Progressive enhancement:
 * without JS the full index is already there and every link works.
 */
(function () {
  function init(root) {
    if (root.__brandAz) return;
    root.__brandAz = true;

    var input  = root.querySelector("[data-brand-filter]");
    var groups = Array.prototype.slice.call(root.querySelectorAll(".brand-az-group"));
    var empty  = root.querySelector("[data-brand-empty]");
    var letters = Array.prototype.slice.call(root.querySelectorAll(".brand-az-letter[data-letter]"));

    function filter(term) {
      var q = (term || "").trim().toLowerCase();
      var anyVisible = false;

      groups.forEach(function (group) {
        var items = group.querySelectorAll("[data-brand-name]");
        var shown = 0;
        Array.prototype.forEach.call(items, function (li) {
          var match = !q || li.getAttribute("data-brand-name").indexOf(q) !== -1;
          li.hidden = !match;
          if (match) shown++;
        });
        group.hidden = shown === 0;
        if (shown) anyVisible = true;
      });

      if (empty) empty.hidden = anyVisible;
    }

    if (input) {
      input.addEventListener("input", function () { filter(input.value); });
      // Enter on a single match goes straight there - saves a tap on mobile.
      input.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        var visible = root.querySelectorAll(".brand-az-group:not([hidden]) [data-brand-name]:not([hidden]) a");
        if (visible.length === 1) { e.preventDefault(); window.location.href = visible[0].href; }
      });
    }

    letters.forEach(function (link) {
      link.addEventListener("click", function () {
        letters.forEach(function (l) { l.classList.remove("is-active"); });
        link.classList.add("is-active");
        if (input) { input.value = ""; filter(""); }
      });
    });
  }

  function boot() { document.querySelectorAll("[data-brand-az]").forEach(init); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
  document.addEventListener("shopify:section:load", boot);
})();
